import api from './../../Api.js';

function Gamification_helper(props) {
  this.props = props;
}

Gamification_helper.prototype.getXpProgress = async function (userId) {
  try {
    var res = await api.getXpProgress(userId);
    this.props.dispatch({ type: 'SET_XP_PROGRESS', data: res.data });
    return { status: 200, data: res.data };
  } catch (e) {
    return { status: e.response ? e.response.status : 500, data: null };
  }
};

Gamification_helper.prototype.getLeaderboard = async function (limit) {
  try {
    var res = await api.getXpLeaderboard(limit);
    this.props.dispatch({ type: 'SET_LEADERBOARD', data: res.data });
    return { status: 200, data: res.data };
  } catch (e) {
    return { status: e.response ? e.response.status : 500, data: [] };
  }
};

Gamification_helper.prototype.getXpEvents = async function (userId, limit) {
  try {
    var res = await api.getXpEvents(userId, limit);
    this.props.dispatch({ type: 'SET_XP_EVENTS', data: res.data });
    return { status: 200, data: res.data };
  } catch (e) {
    return { status: 500, data: [] };
  }
};

Gamification_helper.prototype.getStreak = async function (userId) {
  try {
    var res = await api.getStreak(userId);
    this.props.dispatch({ type: 'SET_STREAK', data: res.data });
    return { status: 200, data: res.data };
  } catch (e) {
    return { status: 500, data: null };
  }
};

Gamification_helper.prototype.getTopStreaks = async function (limit) {
  try {
    var res = await api.getTopStreaks(limit);
    this.props.dispatch({ type: 'SET_TOP_STREAKS', data: res.data });
    return { status: 200, data: res.data };
  } catch (e) {
    return { status: 500, data: [] };
  }
};

Gamification_helper.prototype.getUserMissions = async function (userId) {
  try {
    var res = await api.getUserMissions(userId);
    this.props.dispatch({ type: 'SET_MISSIONS', data: res.data });
    return { status: 200, data: res.data };
  } catch (e) {
    return { status: 500, data: [] };
  }
};

Gamification_helper.prototype.getLevelList = async function () {
  try {
    var res = await api.getLevelList();
    this.props.dispatch({ type: 'SET_LEVEL_LIST', data: res.data });
    return { status: 200, data: res.data };
  } catch (e) {
    return { status: 500, data: [] };
  }
};

Gamification_helper.prototype.listMissions = async function () {
  try {
    var res = await api.listMissions();
    return { status: 200, data: res.data };
  } catch (e) {
    return { status: 500, data: [] };
  }
};

Gamification_helper.prototype.createMission = async function (data) {
  try {
    var res = await api.createMission(data);
    return { status: 201, data: res.data };
  } catch (e) {
    return { status: e.response ? e.response.status : 500, data: null };
  }
};

Gamification_helper.prototype.updateMission = async function (id, data) {
  try {
    var res = await api.updateMission(id, data);
    return { status: 200, data: res.data };
  } catch (e) {
    return { status: 500, data: null };
  }
};

Gamification_helper.prototype.deleteMission = async function (id) {
  try {
    await api.deleteMission(id);
    return { status: 200 };
  } catch (e) {
    return { status: 500 };
  }
};

export default Gamification_helper;
